
import { defineComponent } from 'vue'
import ViewMoreDocuments from '@/components/ViewMoreDocuments.vue'
import DocumentCard from '@/components/DocumentCard.vue'
import { UploadDocumentModalDialog } from '@/components/dialogs'

export default defineComponent({
  name: 'RelatedDocumentsSection',

  components: {
    DocumentCard, ViewMoreDocuments, UploadDocumentModalDialog
  },

  data () {
    return {
      addNewDocument: false
    }
  },

  methods: {
    showNewRelatedDocumentDialog: function () {
      this.addNewDocument = true
    },
    hideNewRelatedDocumentDialog: function () {
      this.addNewDocument = false
    }
  }

})
